import useLoadedValue from "lib/hooks/use-loaded-value";
import {optionsState} from "lib/recoil";

export default function useOption() {
  return useLoadedValue(optionsState);
}
